var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14.5C18 14.88 17.79 15.21 17.47 15.38L9.57 19.82C9.41 19.94 9.21 20 9 20C8.79 20 8.59 19.94 8.43 19.82L0.53 15.38C0.21 15.21 0 14.88 0 14.5V5.5C0 5.12 0.21 4.79 0.53 4.62L8.43 0.18C8.59 0.0600001 8.79 0 9 0C9.21 0 9.41 0.0600001 9.57 0.18L17.47 4.62C17.79 4.79 18 5.12 18 5.5V14.5ZM9 2.15L3.04 5.5L9 8.85L14.96 5.5L9 2.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepFile);
export default __webpack_public_path__ + "static/media/stepFile.21a11f03505b47f06a45f1ef430f0e86.svg";
export { ForwardRef as ReactComponent };